import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import {
  displayDocumentationCell,
  formatReportingPeriod,
} from "../../../../utils/documentationTableHelpers";

const API_BASE = "/scope3/investments";

const mapInvestmentDocumentRow = (item) => ({
  ...item,
  reportingPeriod: displayDocumentationCell(formatReportingPeriod(item)),
});

const InvestmentsDocuments = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = "12% 21% 21% 15% 20% 11%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    investmentType: [],
    investeeProjectName: [],
    countryOfOperation: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `${API_BASE}/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      const rows = response.data.data || [];
      setData(rows.map(mapInvestmentDocumentRow));
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching investments documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`${API_BASE}/filter`);
  //     const {
  //       investmentType,
  //       investeeProjectName,
  //       countryOfOperation,
  //     } = response.data?.data || {};
  //     setFilter({
  //       investmentType: investmentType || [],
  //       investeeProjectName: investeeProjectName || [],
  //       countryOfOperation: countryOfOperation || [],
  //     });
  //   } catch (error) {
  //     console.error("Error fetching investments document filters:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    { title: "Date", key: "createdAt" },
    { title: "Investee/Project Name", key: "investeeProjectName" },
    { title: "Investment Type", key: "investmentType" },
    { title: "Country of operation", key: "countryOfOperation" },
    { title: "Reporting Period", key: "reportingPeriod" },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "date", value: [] },
    {
      title: "Reporting Period",
      type: "reportingYearRange",
      key: "reportingPeriod",
      value: [],
    },
    {
      title: "Investee/Project Name",
      type: "option",
      key: "investeeProjectName",
      value: filter.investeeProjectName || [],
    },
    {
      title: "Investment Type",
      type: "option",
      key: "investmentType",
      value: filter.investmentType || [],
    },
    {
      title: "Country of operation",
      type: "option",
      key: "countryOfOperation",
      value: filter.countryOfOperation || [],
    },
  ];

  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Investments"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />

      {/* <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default InvestmentsDocuments;
